<template>
    <page-drawer>
        <v-list
            expand
            shaped
            nav                     
        >
            <v-list-item 
                link
                class="py-1"                           
                active-class="grey lighten-2 black--text"
                to="/"
            >
                <v-list-item-icon>
                    <v-icon>mdi-menu-left</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                    Back to the Hub
                </v-list-item-title>                            
            </v-list-item>
            <v-subheader>
                Settings
            </v-subheader>
            <v-list-item 
                link
                class="py-1"                           
                active-class="grey lighten-2 black--text"
                to="/ui/infinity/settings/"
            >
                <v-list-item-icon>
                    <v-icon>mdi-robot-industrial</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                    General
                </v-list-item-title>                            
            </v-list-item>
            <is-infinity toggle>
                <v-list-item 
                    link
                    class="py-1"                           
                    active-class="grey lighten-2 black--text"
                    to="/ui/infinity/registries/"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-oci</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                        Image registries
                    </v-list-item-title>                            
                </v-list-item>
            </is-infinity>
            <is-infinity toggle>
                <v-list-item 
                    link
                    class="py-1"                           
                    active-class="grey lighten-2 black--text"
                    to="/ui/infinity/repositories/"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-git</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                        Git repositories
                    </v-list-item-title>                            
                </v-list-item>
            </is-infinity>            
            <v-list-item 
                link
                class="py-1"                           
                active-class="grey lighten-2 black--text"
                to="/ui/infinity/secrets/"
            >
                <v-list-item-icon>
                    <v-icon>mdi-shield-key-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                    Secrets
                </v-list-item-title>                            
            </v-list-item>
            <is-infinity toggle>
                <v-list-item 
                    link
                    class="py-1"                           
                    active-class="grey lighten-2 black--text"
                    to="/ui/infinity/storageclasses/"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-nas</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                        Storage Classes
                    </v-list-item-title>                            
                </v-list-item>
            </is-infinity>
            <v-list-item 
                link
                class="py-1"                           
                active-class="grey lighten-2 black--text"
                to="/ui/infinity/users/"
            >
                <v-list-item-icon>
                    <v-icon>mdi-account-multiple</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                    Users
                </v-list-item-title>                            
            </v-list-item>
        </v-list>                
    </page-drawer>
</template>
<script>
    import PageDrawer from '@/layouts/default/PageDrawer'    
    import { mapWritableState } from 'pinia'
    import { useInterfaceStore } from '@/store/interface-store'

    export default {
        name: 'InfinityDrawer',
        components: {
            PageDrawer,
        },
        computed: {
            ...mapWritableState(useInterfaceStore, ['teal', 'multiverse']),
        },
        mounted () {
            this.teal = true
            this.multiverse = true
        },                
        unmounted () {
            this.teal = false
            this.multiverse = false
        },
        beforeDestroy () {
            this.teal = false
            this.multiverse = false
        },
        deactivated () {
            this.teal = false
            this.multiverse = false
        },
    }
</script>
